export const answersTransformer = (stages, recommendation) => {
  const serviceLevels = {
    level_1: {
      key: 1,
      name: 'essentials_level_1'
    },
    level_2: {
      key: 2,
      name: 'professional_level_2'
    },
    level_3: {
      key: 3,
      name: 'enterprise_level_3'
    }
  };

  let answers = {
    service_level: {},
    q1: [],
    q2: '',
    q3: '',
    q4: '',
    q5: '',
    q6: '',
    q7: '',
    q8: '',
    q9: '',
    q10: '',
    q11: '',
    q12: '',
    q13: '',
    q14: '',
    q15: '',
    q16: [],
    q17: '',
    q18: '',
  };

  if ('both' === recommendation) {
    answers.q1.push('devices');
    answers.q1.push('solutions');
  } else {
    answers.q1.push(recommendation);
  }

  stages.forEach(stage => {
    if (answers.q1.includes(stage.key) && stage.completed) {
      stage.steps.forEach((step) => {
        step.questions.forEach((question) => {
          if (question.answer instanceof Array) {
            answers[question.key] = [];

            question.answer.forEach((answer) => {
              answers[question.key].push(answer.key);
            });
          } else {
            answers[question.key] = question.answer.key;
          }
        })
      });
    }
  });

  answers.service_level = serviceLevels.level_3;
  if (
    'yes' === answers.q3 &&
    'no' === answers.q4 &&
    'no' === answers.q9 &&
    'no' === answers.q10
  ) {
    answers.service_level = serviceLevels.level_1;
  } else if (
    'no' === answers.q4 &&
    'yes' === answers.q9 &&
    'no' === answers.q10
  ) {
    answers.service_level = serviceLevels.level_2;
  }

  return answers;
};

export const answersTransformerRevert = (stages, answers) => {
  answers.q1.forEach((value) => {
    stages.forEach((stage, stageIndex) => {
      stages[stageIndex].completed = true;
      if (stage.key === value) {
        stage.steps.forEach((step, stepIndex) => {
          stages[stageIndex].steps[stepIndex].completed = true;
          step.questions.forEach((question, questionIndex) => {
            if(answers[question.key]) {
              stages[stageIndex].steps[stepIndex].questions[questionIndex].answer = { key: answers[question.key], text:  answers[question.key] };
            }
          });
        });
      }
    });
  });

  return stages;
};
